import React from 'react';
import { useAdminConfig } from '../../hooks/useAdminConfig';
import { Card } from '../../components/ui/Card';
import { SLARuleEditor } from '../../components/admin/SLARuleEditor';
import { LoadingSpinner } from '../../components/ui/Feedback';
import { SlidersHorizontal } from 'lucide-react';

export const SLAConfigPage: React.FC = () => {
  const { priorities, isLoading, updatePriority, createPriority, deletePriority } = useAdminConfig();

  if (isLoading) return <LoadingSpinner size="lg" text="Loading SLA Rules..." />;

  return (
    <div className="space-y-5">
      <div>
        <h3 className="text-lg font-semibold text-slate-100 flex items-center gap-2">
          <SlidersHorizontal className="w-5 h-5 text-sky-400" />
          SLA Rules Configuration
        </h3>
        <p className="text-xs text-slate-400">Configure resolution SLA hours and warning thresholds per priority level</p>
      </div>

      <Card title="SLA Duration & Escalation Rules">
        <SLARuleEditor
          priorities={priorities}
          onUpdate={updatePriority}
          onCreate={createPriority}
          onDelete={deletePriority}
        />
      </Card>
    </div>
  );
};
